import { Field } from '@sitecore-content-sdk/nextjs';
import React from 'react';
import { tv } from 'tailwind-variants';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { getTestProps } from 'lib/testing/utils';

export type GuidanceSectionProps = {
  guidanceBlock?: {
    title?: Field<string>;
    description?: Field<string>;
  };
};

const STYLES = tv({
  slots: {
    guidanceCard: ['lg:w-[48.83%]', 'order-1', 'lg:order-2'],
    guidanceCardContent: [
      'bg-component-article-card-surface',
      'border',
      'border-component-article-card-border',
      'rounded-general-border-radius-card',
      'shadow-[0_0_8px_0_rgba(0,0,0,0.1)]',
      'p-padding-base',
      'flex',
      'flex-col',
      'gap-spacing-spacing-24',
      'lg:w-[424px]',
    ],
    guidanceTitle: [
      'font-typography-font-family-body',
      'font-typography-font-weight-body-bold',
      'text-color-core-color-1-Navy',
    ],
    guidanceDescription: [
      'font-typography-font-family-body',
      'font-typography-font-weight-body',
      'text-color-core-color-1-Navy',
    ],
  },
});

const { guidanceCard, guidanceCardContent, guidanceTitle, guidanceDescription } = STYLES();

const GuidanceSection = (props: GuidanceSectionProps): React.JSX.Element => {
  const { guidanceBlock } = props;

  if (!guidanceBlock?.title || !guidanceBlock?.description) {
    return <div />;
  }

  return (
    <aside className={guidanceCard()}>
      <div className={guidanceCardContent()}>
        <PlainTextWrapper
          className={guidanceTitle()}
          field={guidanceBlock?.title}
          tag="h6"
          encode={false}
          {...getTestProps(`guidance-title`)}
        />
        <RichTextWrapper
          className={guidanceDescription()}
          field={guidanceBlock?.description}
          encode={false}
          {...getTestProps(`guidance-description`)}
        />
      </div>
    </aside>
  );
};

export default GuidanceSection;
